import type { Theme } from './types';

export const cleanLightTheme: Theme = {
  name: 'Clean Light',
  id: 'clean-light',
  colours: {
    background: {
      primary: '#f8f9fa',
      secondary: '#f0f1f3',
      tertiary: '#e8e9eb',
      elevated: '#dfe0e2',
    },
    text: {
      primary: '#1a1a2e',
      secondary: '#4a4a5e',
      tertiary: '#7a7a8e',
      inverse: '#f8f9fa',
    },
    accent: {
      primary: '#3b82f6',
      secondary: '#8b5cf6',
      success: '#22c55e',
      warning: '#f59e0b',
      error: '#ef4444',
    },
    feedback: {
      placed: '#22c55e',
      misplaced: '#f59e0b',
      incorrect: '#94a3b8',
    },
    rarity: {
      common: '#64748b',
      uncommon: '#16a34a',
      rare: '#2563eb',
      epic: '#9333ea',
      legendary: '#ca8a04',
    },
    powerUp: {
      boost: '#f59e0b',
      surge_i: '#ef4444',
      surge_ii: '#ec4899',
      oracle: '#8b5cf6',
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  typography: {
    fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '1.5rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },
  borders: {
    radius: {
      sm: '0.25rem',
      md: '0.5rem',
      lg: '0.75rem',
      full: '9999px',
    },
    width: {
      thin: '1px',
      normal: '2px',
      thick: '3px',
    },
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.15)',
    glow: '0 0 20px rgba(59, 130, 246, 0.2)',
  },
  transitions: {
    fast: '150ms ease-in-out',
    normal: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
  scanlineAlpha: 0,
  vignetteEnabled: false,
  fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
  rarityColours: {
    common: '#64748b',
    uncommon: '#16a34a',
    rare: '#2563eb',
    epic: '#9333ea',
    legendary: '#ca8a04',
  },
  powerUpColours: {
    oracle: '#8b5cf6',
    surge: '#ef4444',
    boost: '#f59e0b',
  },
};
